// AiReports::Period の比較期間と同じ規則(設計書 2026-10-15 §4)。日付は UTC の Date で扱う
const DAY_MS = 24 * 60 * 60 * 1000

function pad(n) {
  return String(n).padStart(2, "0")
}

function ymd(date) {
  return `${date.getUTCFullYear()}/${pad(date.getUTCMonth() + 1)}/${pad(date.getUTCDate())}`
}

// AiReports::Period.label と同じ形。同年なら終わりの年を省く
export function periodLabel(from, to) {
  const end = from.getUTCFullYear() === to.getUTCFullYear() ? `${pad(to.getUTCMonth() + 1)}/${pad(to.getUTCDate())}` : ymd(to)
  return `${ymd(from)}〜${end}`
}

const utc = (y, m, d) => new Date(Date.UTC(y, m, d))
const monthEnd = (y, m) => utc(y, m + 1, 0)

// ちょうど暦の1か月 → 暦の前月、ちょうど暦の四半期 → 暦の前四半期、それ以外 → 直前の同じ日数
export function comparePeriod(from, to) {
  const y = from.getUTCFullYear()
  const m = from.getUTCMonth()
  const isMonthStart = from.getUTCDate() === 1
  if (isMonthStart && to.getTime() === monthEnd(y, m).getTime()) {
    return { from: utc(y, m - 1, 1), to: monthEnd(y, m - 1) }
  }
  if (isMonthStart && m % 3 === 0 && to.getTime() === monthEnd(y, m + 2).getTime()) {
    return { from: utc(y, m - 3, 1), to: monthEnd(y, m - 1) }
  }
  const days = Math.round((to - from) / DAY_MS) + 1
  return { from: new Date(from.getTime() - days * DAY_MS), to: new Date(from.getTime() - DAY_MS) }
}
